import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Input } from "semantic-ui-react";

const InputDateField = ({ ...props }) => {
    useEffect(() => {
        todaysDate()
    }, []);

    const todaysDate = () => {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }

        today = yyyy + '-' + mm + '-' + dd;
        props.data.lr_date = today;
        document.getElementById("input-date-field").defaultValue = today + "";
    }

    const handleOnChange = (e) => {
        props.data.lr_date = e.target.value
    };

    return (
        <Input
            id="input-date-field"
            className="width-100cent"
            type="date"
            onChange={e => handleOnChange(e)}
        />
    )
}

export default InputDateField;
